import React from "react"
import { Link } from "react-router-dom"

export default function BaseKanban() {
	return (
		<div className="wrap mbtm">
			<div className="contents">
				<div className="tag">
					<div className="title_area">
						<div className="qs_area">
							<span className="qs">Quick Search</span>
							<svg width="37" height="23" viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="GroupTalkList_icon__FmZ_E">
								<path d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18H9.82008C10.3479 19.0955 10.1802 20.7342 8.81892 22.2349C8.66888 22.4003 8.84741 22.7082 9.05749 22.6324C12.0154 21.566 16.5287 19.6397 17.7637 18H28C32.9706 18 37 13.9706 37 9C37 4.02944 32.9706 0 28 0H9Z" fill="currentColor"></path>
								<path d="M7.78223 13H5.91309V5.24951H7.48682L10.7148 9.61084H10.8169V5.24951H12.686V13H11.123L7.88428 8.5957H7.78223V13ZM19.8296 11.4155V13H14.5176V5.24951H19.8296V6.83398H16.4888V8.38086H19.6309V9.83105H16.4888V11.4155H19.8296ZM26.2158 8.25195L24.9429 13H23.0845L21.0596 5.24951H23.106L24.1372 10.3896H24.2339L25.4746 5.24951H27.0537L28.3374 10.3896H28.4341L29.4492 5.24951H31.4795L29.4546 13H27.6069L26.3125 8.25195H26.2158Z" fill="white"></path>
							</svg>
						</div>
						<div className="qs_sub">원하는 API 정보를 바로 찾아보세요</div>
						<div className="qs_list">
							<Link to="/content?msa=common&depth=알림메시지%20전송">
								<button className="" type="button" role="option">
									# 알림메시지전송
								</button>
							</Link>
							<Link to="/content?msa=display&depth=표준카테고리">
								<button className="" type="button" role="option">
									# 표준카테고리
								</button>
							</Link>
							<Link to="/content?msa=event&depth=이벤트%20관리">
								<button className="" type="button" role="option">
								# 이벤트관리
								</button>
							</Link>
							<Link to="/content?msa=member&depth=마일리지">
								<button className="" type="button" role="option">
								# 마일리지
								</button>
							</Link>
							<Link to="/content?msa=member&depth=위시리스트">
								<button className="" type="button" role="option">
								# 위시리스트
								</button>
							</Link>
						</div>
					</div>
				</div>
				<section className="ce">
					<div>
						<Link to="/content?msa=common">
							<span className="box">
								<span className="p_tit">공통(Common) API</span>
								<span className="bn01"></span>
							</span>
							<span className="b_tit">알림메시지 및 공통코드, 금칙어 등을 조회할 수 있는 공통 API 설명서입니다.</span>
						</Link>
					</div>
					<div>
						<Link to="/content?msa=display">
							<span className="box">
								<span className="p_tit">전시(Display) API</span>
								<span className="bn02"></span>
							</span>
							<span className="b_tit">프론트 관리에 필요한 카테고리, 사이트, 전시매장 및 몰 관리, 기획전 관리 등에 대한 전시 API 설명서입니다.</span>
						</Link>
					</div>
					<div>
						<Link to="/content?msa=event">
							<span className="box">
								<span className="p_tit">이벤트(Events) API</span>
								<span className="bn03"></span>
							</span>
							<span className="b_tit">이벤트 응모 회원 관리, 참여내역 및 목록, 관련 댓글 수정/삭제 등에 대한 이벤트 API 설명서입니다.</span>
						</Link>
					</div>
				</section>
				<section className="go">
					<div>
						<Link to="/content?msa=goods">
							<span className="box">
								<span className="p_tit">상품(Goods) API</span>
								<span className="bn04"></span>
							</span>
							<span className="b_tit">상품 검색, 상품평, Q&A, 증정품, 브랜드 및 상품 상세 정보 등에 대한 상품 API 설명서입니다.</span>
						</Link>
					</div>
					<div>
						<Link to="/content?msa=member">
							<span className="box">
								<span className="p_tit">회원(Member) API</span>
								<span className="bn05"></span>
							</span>
							<span className="b_tit">로그인, 회원정보, 알림함, 마일리지, 마이페이지 및 위시리스트 등에 대한 회원 API 설명서입니다.</span>
						</Link>
					</div>
					<div>
						<Link to="/content?msa=order">
							<span className="box">
								<span className="p_tit">주문(Order) API</span>
								<span className="bn06"></span>
							</span>
							<span className="b_tit">장바구니, 주문서 생성, 주문/배송 조회, 취소/반품/교환 및 관련 고객센터 등에 대한 주문 API 설명서입니다.</span>
						</Link>
					</div>
				</section>
			</div>
		</div>
	)
}
